export default __webpack_public_path__ + "static/media/destino7.b1f9e38d.png";